<template>
  <button
    type="button"
    aria-label="Afficher mon flux d'activités"
    class="button-feed"
    @click="handleClickFeed"
  >
    <icon class="icon" name="nomad:bell" size="3.2rem" />
    <div class="badge">
      <BadgeNotification theme="red" :count="feedStore.newFeedsCount" />
    </div>
  </button>
</template>
<script lang="ts" setup>
import DialogFeed from '~/components/dialog/feed/DialogFeed.vue';
const profile = useProfileStore();
const dialog = useDialogStore();

const feedStore = useFeedStore();

const { refreshReadItems } = useFeedRefreshReadItems();

const handleClickFeed = () => {
  dialog.open(DialogFeed, {
    level: DialogLevel.Settings,
    position: 'top-right',
    onClose: () => {
      refreshReadItems();
    },
  });
};
</script>
<style lang="scss" scoped>
.button-feed {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: flex-start;
  width: auto;
  height: 4rem;
  &.disabled {
    pointer-events: none;
  }

  cursor: pointer;

  @include above('l') {
    height: 5rem;
  }

  .icon {
    transition: transform 300ms $ease-out-back;
  }

  &:hover,
  &:focus {
    @include above('l') {
      .icon {
        transform: scale(1.3);
      }

      .badge {
        transform: scale(1) translateY(-0.2rem) translateX(0);
      }
    }
  }
}

.badge {
  position: absolute;
  right: -0.5rem;
  bottom: 0;
  transform: scale(0.8);
  transition: transform 400ms $ease-out-back-custom;
}
</style>
